// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy h1 {
  font-size: 62px;
  font-weight: 700;
  margin-bottom: 32px;
}

.privacy-policy h3 {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 20px;
}

.privacy-policy h5 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 16px;
}

.privacy-policy p {
  margin-bottom: 20px;
}

.privacy-policy ul {
  margin-left: 24px;
  list-style-type: disc;
  margin-bottom: 20px;
}

.privacy-policy ul li {
  margin-bottom: 12px;
}

.privacy-policy small {
  margin-bottom: 20px;
  display: block;
}

.privacy-policy table {
  margin: 32px 0px;
  border-collapse: collapse;
}

.privacy-policy tr {
  border-bottom: 1px solid slategrey;
  border-top: 1px solid slategrey;
}

.privacy-policy td,
th {
  padding: 12px 0px;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}

.privacy-policy th {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/privacy-policy.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".privacy-policy h1 {\n  font-size: 62px;\n  font-weight: 700;\n  margin-bottom: 32px;\n}\n\n.privacy-policy h3 {\n  font-size: 24px;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.privacy-policy h5 {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 16px;\n}\n\n.privacy-policy p {\n  margin-bottom: 20px;\n}\n\n.privacy-policy ul {\n  margin-left: 24px;\n  list-style-type: disc;\n  margin-bottom: 20px;\n}\n\n.privacy-policy ul li {\n  margin-bottom: 12px;\n}\n\n.privacy-policy small {\n  margin-bottom: 20px;\n  display: block;\n}\n\n.privacy-policy table {\n  margin: 32px 0px;\n  border-collapse: collapse;\n}\n\n.privacy-policy tr {\n  border-bottom: 1px solid slategrey;\n  border-top: 1px solid slategrey;\n}\n\n.privacy-policy td,\nth {\n  padding: 12px 0px;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.privacy-policy th {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
